module.exports = __webpack_public_path__ + "static/media/whiteLogoAnimado.6347a800.gif";